import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

/**
 * Tiny one-line trust strip used on onboarding, checkout, and chat surfaces.
 * Subtle. Honest. Links to the plain-English Privacy Promise.
 */
export default function TrustLine({ className = "", variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <div
      data-testid="trust-line"
      className={`inline-flex items-start gap-2 font-body text-[12px] leading-snug ${
        isDark ? "text-white/65" : "text-[#6b7280]"
      } ${className}`}
    >
      <Lock size={11} className={`mt-0.5 shrink-0 ${isDark ? "text-white/55" : "text-[#3e6b52]"}`} />
      <span>
        Your personal information stays private. We do not sell your data, share your private entries with advertisers, or make your personal goals public.{" "}
        <Link
          to="/privacy-promise"
          className={`underline underline-offset-2 ${isDark ? "text-white/85 hover:text-white" : "text-[#486a8f] hover:text-[#3a5a7c]"}`}
        >
          Read our Privacy Promise
        </Link>
        .
      </span>
    </div>
  );
}
